module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/scale-new/scale-new.component.css
// module id = ./src/app/admin/scale-new/scale-new.component.css
// module chunks = main